import React, { forwardRef, useImperativeHandle, useRef } from "react"
import { FormControl } from "react-bootstrap"
import clsx from "clsx"

import { farsiToEnglishDigitConverter } from "utils"
import classes from "./Input.module.scss"

const plusKeyCode = 107
const minusKeyCode = 109
const pointKeyCode = 110
const spaceKeyCode = 32

const Input = (props, outerRef) => {
  const {
    type = "text",
    min,
    max,
    value,
    maxLength = -1,
    withoutSpace = false,
    numberType,
    componentType = "input",
    onChange = () => { },
    onKeyDown = () => { },
    onPaste = () => { },
    className,
    ...otherProps
  } = props

  const innerRef = useRef(null)

  useImperativeHandle(outerRef, () => innerRef.current, [])

  const handleChange = e => {
    const start =
      innerRef.current.selectionStart

    const end =
      innerRef.current.selectionEnd

    e.target.value =
      farsiToEnglishDigitConverter(e.target.value)

    // preserve cursor position
    type === "text" &&
      innerRef.current.setSelectionRange(start, end)

    if (type === "number") {
      if (max !== undefined && Number(e.target.value) > max) return

      if (min !== undefined && Number(e.target.value) < min) return

      if (
        !!String(e.target.value)[1] &&
        String(e.target.value)[0] === "0" &&
        String(e.target.value)[1] !== "."
      ) return

      onChange(e)

      return
    }

    onChange(e)
  }

  const handleKeyDown = e => {
    if (
      type === "number" &&
      numberType === "int" &&
      (e.keyCode === 190 || e.keyCode === pointKeyCode)
    ) return e.preventDefault()

    if (
      withoutSpace &&
      e.keyCode === spaceKeyCode
    ) return e.preventDefault()

    if (
      type === "number" &&
      min === 0 &&
      (e.keyCode === 45 || e.keyCode === minusKeyCode)
    ) return e.preventDefault()

    if (
      type === "number" &&
      (e.keyCode === 43 || e.keyCode === plusKeyCode)
    ) return e.preventDefault()

    onKeyDown(e)
  }

  const handlePaste = e => {
    let pastedText

    if (window.clipboardData && window.clipboardData.getData) {
      pastedText = window.clipboardData.getData("Text")
    } else if (e.clipboardData && e.clipboardData.getData) {
      pastedText = e.clipboardData.getData("text/plain")
    }

    if (
      type === "number" &&
      isNaN(pastedText)
    ) return e.preventDefault()

    if (
      type === "number" &&
      numberType === "int" &&
      Number(pastedText) % 1 !== 0
    ) return e.preventDefault()

    if (
      pastedText.length > maxLength &&
      maxLength !== -1
    ) return e.preventDefault()

    onPaste(e)
  }

  if (componentType === "bootstrap") {
    return (
      <FormControl
        inputRef={(ref) => innerRef.current = ref}
        type={type}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
        className={clsx(classes["bt-input"], className)}
        maxLength={maxLength}
        onWheel={(e) => e.target.blur()}
        {...otherProps}
      />
    )
  }

  return (
    <input
      ref={innerRef}
      type={type}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onPaste={handlePaste}
      className={className}
      maxLength={maxLength}
      onWheel={(e) => e.target.blur()}
      {...otherProps}
    />
  )
}

export default forwardRef(Input)